import Cache from 'admin/editor/cache';
import { debounce } from 'vendor/lodash.debounce';

export default class EmbedElement {
  constructor(options) {
    this.learnEditor = options.editor;
    this.savedUrl = null;
    this.savedPreviewUrl = null;
    this.activeElementId = null;
    this.activePosition = null;

    this.cache = new Cache('embed');

    this.init();
  }

  init() {
    const ua = navigator.userAgent,
      action = (ua.match(/iPad/i)) ? "touchstart" : "click";

    $(document).on('click', '.add-build-embed', this.newElement.bind(this));
    $(document).on(action, '.submit-build-embed', this.submitElement.bind(this));
    $(document).on(action, '.cancel-build-embed', this.cancelElement.bind(this));
    $(document).on(action, '.delete-build-embed', this.deleteElement.bind(this));
    $(document).on(action, '.edit-embed-link', this.editElement.bind(this));
  }

  shouldShowButton() {
    return true;
  }

  addButtonTemplate() {
    return '<a class="add-build-embed" href="#"><i class="fa fa-film"></i>Embed</a>';
  }

  newElement(event) {
    event.preventDefault();

    let link = $(event.currentTarget);

    //only one editor should be enabled at a time
    if (this.learnEditor.is_editor_enabled()) {
      return;
    }

    this.savedUrl = null;
    this.savedPreviewUrl = null;

    const cachedUrl = this.cache.get('url') || "";

    this.insertEmbed(link.closest('.button-bar, .bottom-button-bar'), cachedUrl);
    this.learnEditor.editing();
  }

  async submitElement(event) {
    event.preventDefault();
    const $element = $(event.currentTarget).closest('.build-embed-wrapper');

    const url = $('.build-input').val();

    const validator = await this.validateEmbed(url);
    if (!validator.valid) {
      // display error message and return
      $('.embed-errors').html(`Error: ${validator.message}`);
      return false;
    }

    this.savedUrl = null;
    this.savedPreviewUrl = null;
    this.addEmbed($element, url, this.activeElementId, this.activePosition);
    this.activeElementId = "";
    this.activePosition = "";

    this.learnEditor.save_page("Before Added Embed Element");
  }

  async validateEmbed(url) {
    if ($('input[name="page_type"]').val() === 'user') {
      var requestUrl = `/elements/validate_embed.json?url=${url}`;
    } else {
      var requestUrl = `/admin/elements/validate_embed.json?url=${url}`;
    };
    const response = await fetch(requestUrl);

    const data = await response.json();
    return data;
  }

  editElement(event) {
    event.preventDefault();
    //or if an editor is already present
    if(this.learnEditor.is_editor_enabled()) { //only one editor should be enabled at a time
      return;
    }

    let $element = $(event.currentTarget).closest('.build-embed');

    const url = $(".embed-content a", $element).html();

    const cachedUrl = this.cache.get('url');

    //backup the text, save it in case of cancelling
    this.savedUrl = url;
    this.savedPreviewUrl = $('.preview-url', $element).attr('href');
    this.activeElementId = $element.attr('id');
    this.activePosition = $element.data('position');
    this.insertEmbed($element, cachedUrl || url);
    this.learnEditor.centerInView($('.build-embed-wrapper'));
    this.learnEditor.editing();
  }

  cancelElement(event) {
    event.preventDefault();

    let $element = $(event.currentTarget);

    //restore with global saved text
    this.addEmbed($element.closest('.build-embed-wrapper'),
                  this.savedUrl,
                  this.activeElementId,
                  this.activePosition,
                  this.savedPreviewUrl);
    this.activeElementId = "";
    this.activePosition = "";

    this.learnEditor.finishEditing();
    this.cache.delete();
  }

  deleteElement(event) {
    event.preventDefault();

    let $element = $(event.currentTarget);


    if (!confirm("Confirm deletion of this element.")) {
      return;
    }

    $element.closest('.build-embed-wrapper').remove();

    this.savedUrl = null;
    this.savedPreviewUrl = null;
    this.activeElementId = "";
    this.activePosition = "";

    this.learnEditor.save_page("Before Deleted Embed Element");
    this.cache.delete();
  }

  insertEmbed($element, title, content) {
    const buildText = this.buildEmbed(title, content);

    $element.hide();
    let $build_text = $(buildText).hide();
    $element.replaceWith($build_text);
    $('.build-embed-wrapper').show();

    this.watchState($build_text);
    this.learnEditor.centerInView($('.build-embed-wrapper'));
  }

  watchState($element) {
    var saveState = function(event) {
      this.cache.save({ url: event.currentTarget.value });
    }
    $element.find('input').on('keyup', debounce(saveState.bind(this), 500));
  }

  buildEmbed(url = "") {
    url = url.replace(/'/g, "&#40;").trim();

    let buildText =
      `<div class='row-fluid build-embed-wrapper'>
        <label>Enter embed URL</label>
        <input class='build-input span12' style='display=block;' value='${url}' />
        <p class="help">Supported formats are YouTube, GitHub, and nearly anything with oembed support.
          For GitHub project bundles, the '?type=py/mpy' parameter is an option.</p>
        <div class='embed-errors'></div>
        <div class='editor-buttons'>
          <button class='delete-build-embed delete'>Delete</button>
          <button class='cancel-build-embed cancel'>Cancel</button>
          <button class='submit-build-embed save'>Save</button>
        </div>
      </div>`;

    let $buildText = $(buildText);

    return $buildText;
  }

  addEmbed($element, url, id, position, previewUrl = "") {
    url = $.trim(url);

    var embedHtml =
      `<div id='${id || ""}' class='element embed-element build-embed' data-position='${position || ""}'>
        <span class="oembed">
          Embedded Content |
          <a target="_blank" rel="noopener noreferrer" href="${previewUrl}" class="preview-link">preview page with embed</a> |
          <a href="#" class="edit-embed-link">edit</a>
          <div class="embed-content">
            <a target="_blank" rel="noopener noreferrer" href="${url}">${url}</a>
          </div>
        </span>
      </div>`;

    if (url) {
      $element.replaceWith(embedHtml);
    } else {
      $element.remove();
    }
  }
}
